import { LngLatZoom } from 'app/types/lng-lat-zoom';
import { ProjectConfig } from './../../../types/project-config';
import { StatefulCSS } from './../../../model/stateful_css';
import { MapBoxPlace } from './../../address-finder/address-finder.component';
import { GeocodeService } from './../../../model/services/geocode.service';
import { Decorable } from './../../../types/decorable';
import { Component, OnInit, ViewChild, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, tap, switchMap } from 'rxjs/operators';

import { NgbTypeahead, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { LngLat } from 'mapbox-gl';
@Component({
  selector: 'app-project-general-cfg-view',
  templateUrl: './general-view.component.html',
  styleUrls: ['./general-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GeneralViewComponent implements OnInit {
  public searching = false;
  public searchFailed = false;
  public value: any = {};
  public attribution = '';
  public set name(val: string) {
    if (!this.projectConfig) return;
    this.projectConfig.general.name = val;
    this.cdr.detectChanges();
  }
  public get name(): string {
    if (!this.projectConfig) return '';
    if (!this.projectConfig.general.name) return '';
    return this.projectConfig.general.name;
  }
  public set lng(val: number) {
    if (!this.projectConfig) return;
    this.projectConfig.general.location.lng = val;
    this.cdr.detectChanges();
  }
  public get lng(): number {
    if (!this.projectConfig) return 0;
    return this.projectConfig.general.location.lng;
  }
  public set lat(val: number) {
    if (!this.projectConfig) return;
    this.projectConfig.general.location.lat = val;
    this.cdr.detectChanges();
  }
  public get lat(): number {
    if (!this.projectConfig) return 0;
    return this.projectConfig.general.location.lat;
  }
  public set zoom(val: number) {
    if (!this.projectConfig) return;
    this.projectConfig.general.location.zoom = val;
    this.cdr.detectChanges();
  }
  public get zoom(): number {
    if (!this.projectConfig) return 0;
    return this.projectConfig.general.location.zoom;
  }
  public area: string = 'location';
  private stateMgr!: StatefulCSS;

  get searchParams(): any {
    const params: Decorable = {};
    params.autoComplete = true;

    return params;
  }
  private projectConfig?: ProjectConfig;
  @Input('config')
  set config(projectConfig: ProjectConfig | undefined) {
    this.projectConfig = projectConfig;
    if(!!this.projectConfig?.general.location.lat) {
      this.area = 'custom';
      this.SetArea(this.area);
    }
    this.Refresh();

  }
  get config(): ProjectConfig | undefined {
    return this.projectConfig;
  }
  @Output() configChange = new EventEmitter<ProjectConfig>();

  @ViewChild('rt', { static: false }) rt!: TemplateRef<ElementRef>;
  @ViewChild('locSearchGrp', { static: true }) locSearchGroup!: ElementRef<HTMLDivElement>;
  @ViewChild(NgbTypeahead, { static: true }) locSearch!: NgbTypeahead;
  public locSearchResults: any;

  private _ready = false;

  constructor(private service: GeocodeService, private cdr: ChangeDetectorRef, private domNode: ElementRef
  ) { }
  ngOnInit():void {
    this.stateMgr = new StatefulCSS();
    this.stateMgr.SetPrefix('area');
    this.stateMgr.AddState('custom');
    this.stateMgr.AddState('location');
    this.stateMgr.SetMachine(this.domNode.nativeElement);
    this.stateMgr.SetState('location');
    this._ready = true;

    /*this.locSearch.selectItem.subscribe((event: NgbTypeaheadSelectItemEvent) => {
      this.attribution = this.service.lastResults.attribution;
      const locSearch = document.getElementById('locSearch');
      if (locSearch) {
        locSearch.setAttribute('title', this.attribution);
      }
      if (event.item.hasOwnProperty('bbox')) {
        this.value.bbox = event.item.bbox;
      }
      this.value.point = new LngLat(event.item.center[0], event.item.center[1]);
    });
    */
    const locSearchElement = document.getElementById('locSearch');
    if (!!locSearchElement) {
      locSearchElement.addEventListener('keyup', (event: any) => {
        switch (event.keyCode) {
          case 13:
            this.Refresh();
            break;
        }
        this.Refresh();
      })
    }
    this.Refresh();
  }
  HandleAddress(address: MapBoxPlace) {
    this.lng = address.center[0];
    this.lat = address.center[1];
    this.zoom = 15;
    this.NotifyListeners();
    this.stateMgr.SetState('custom');
    this.SetArea('custom');
    this.Refresh();


  }
  SetArea(which: string) {
    if (this.area !== which) {
      this.area = which;
    }
    this.stateMgr.SetState(which);
    this.Refresh();
  }
  NotifyListeners() {
    this.configChange.emit(this.projectConfig);
  }
  GPS() {
    this.service.GetGPSLocation((location: LngLatZoom | undefined) => {
      if (!location) return;
      this.lng = location.lng;
      this.lat = location.lat;
      this.zoom = location.zoom;
      this.SetArea('custom');
      this.cdr.markForCheck();
      this.Refresh();
      this.NotifyListeners();
    });
  }
  Refresh() {
    if(this._ready === true) {
      this.cdr.detectChanges();
    }
  }
}
